import React from 'react';
import '../template-file-css/document-file-template.css';


export const PCS_DischargeSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='PCS_DischargeSummary' className='file-pdf-document'>

            <div className='file-template'>
            <p className='w-750'>
                    <span className='eleHeader'>DISCHARGE SUMMARY</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDischargeSummary_1' name='cbDischargeSummary_1' className='add-only' value='MobileCrisisResponse' /> Mobile Crisis Response
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDischargeSummary_2' name='cbDischargeSummary_2' className='add-only' value='HourComStab' /> {`23-Hour/Com Stab`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDischargeSummary_3' name='cbDischargeSummary_3' className='add-only' value='MentalHealthSkillBuilding' /> Mental Health Skill Building
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDischargeSummary_4' name='cbDischargeSummary_4' className='add-only' value='IntensiveInHome' /> {`Intensive In-Home`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDischargeSummary_5' name='cbDischargeSummary_5' className='add-only' value='Opt' /> OPT
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Individual Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>{`Insurance Name/#:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtIndividualName' name='txtIndividualName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtInsuranceName' name='txtInsuranceName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Individual Full Address:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtIndividualFullAddress' name='txtIndividualFullAddress' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Parent/Guardian Name/Phone#/Full Address:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtParentGuardianNamePhoneFullAddress' name='txtParentGuardianNamePhoneFullAddress' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>DOB:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Date of Admission:`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Date of Discharge:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfAdmission' name='txtDateOfAdmission' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfDischarge' name='txtDateOfDischarge' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Reason for Discharge:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForDischarge_1' name='cbReasonForDischarge_1' className='add-only' value='PoorContact' /> Poor Contact
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForDischarge_2' name='cbReasonForDischarge_2' className='add-only' value='IndividualRelocated' /> {`Individual Relocated`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForDischarge_3' name='cbReasonForDischarge_3' className='add-only' value='InsuranceChangeInactive' /> {`Insurance Change/Inactive`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForDischarge_4' name='cbReasonForDischarge_4' className='add-only' value='Noncompliance' /> {`Noncompliance`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForDischarge_5' name='cbReasonForDischarge_5' className='add-only' value='IndividualWithdrew' /> Individual Withdrew
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReasonForDischarge_6' name='cbReasonForDischarge_6' className='add-only' value='CompletedServices' /> Completed Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReasonForDischarge_7' name='cbReasonForDischarge_7' className='add-only' value='Other' /> Other
                            <input type='text' id='txtReasonForDischarge' name='txtReasonForDischarge' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Individual/Authorization Representative Participation in Discharge Planning:`}</span>
                    <textarea id='txtindividualAuthorizationRepresentative' name='txtindividualAuthorizationRepresentative' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summary of Services Provided & Frequency</span>
                    <span className='small'>{`Summary of Treatment Experience/problems encountered by the consumer and the family during assessedneeds not met during care, and reasons why:`}</span>
                    <textarea id='txtSummaryServicesProvidedFrequency' name='txtSummaryServicesProvidedFrequency' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3> Mental Health Discharge Information:</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Discharge Diagnosis </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDischargeDiagnosis_1' name='txtDischargeDiagnosis_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDischargeDiagnosis_2' name='txtDischargeDiagnosis_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDischargeDiagnosis_3' name='txtDischargeDiagnosis_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDischargeDiagnosis_4' name='txtDischargeDiagnosis_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDischargeDiagnosis_5' name='txtDischargeDiagnosis_5' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Medication Name</span>
                        </td>
                        <td className='w-150'> <span className='eleHeader'>Dosage/Frequency</span>
                        </td>
                        <td className='w-150'> <span className='eleHeader'>Provider Name</span>
                        </td>
                        <td className='w-300'> <span className='eleHeader'>{`Provider Phone & Address`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosageFrequency_1' name='txtDosageFrequency_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtProviderPhoneAddress_1' name='txtProviderPhoneAddress_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtMedicationName_2' name='txtMedicationName_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosageFrequency_2' name='txtDosageFrequency_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtProviderPhoneAddress_2' name='txtProviderPhoneAddress_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtMedicationName_3' name='txtMedicationName_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosageFrequency_3' name='txtDosageFrequency_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtProviderPhoneAddress_3' name='txtProviderPhoneAddress_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtMedicationName_4' name='txtMedicationName_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosageFrequency_4' name='txtDosageFrequency_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtProviderName_4' name='txtProviderName_4' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtProviderPhoneAddress_4' name='txtProviderPhoneAddress_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtMedicationName_5' name='txtMedicationName_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDosageFrequency_5' name='txtDosageFrequency_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtProviderName_5' name='txtProviderName_5' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtProviderPhoneAddress_5' name='txtProviderPhoneAddress_5' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Primary Care Provider:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPrimaryCareProvider' name='txtPrimaryCareProvider' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Psychiatrist:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPsychiatrist' name='txtPsychiatrist' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>{`LMHP/LMHP-E:`}</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtLmhpLmhpe' name='txtLmhpLmhpe' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>MCO Coordinator:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtMCOCoordinator' name='txtMCOCoordinator' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Date of Last Psychiatric Eval:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDateofLastPsychiatricEval' name='txtDateofLastPsychiatricEval' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Date of Last Medical Checkup:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtDateofLastMedicalCheckup' name='txtDateofLastMedicalCheckup' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Treatment Goals and Objectives</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 1:</span>
                    <textarea id='txtGoal_1' name='txtGoal_1' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Goal Status:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusOne_1' name='cbGoalStatusOne_1' className='add-only' value='Achieved' /> Achieved
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusOne_2' name='cbGoalStatusOne_2' className='add-only' value='ModerateProgressMade' /> Moderate Progress Made
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusOne_3' name='cbGoalStatusOne_3' className='add-only' value='MinimalProgressMade' /> Minimal Progress Made
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusOne_4' name='cbGoalStatusOne_4' className='add-only' value='NoProgressMade' /> No Progress Made
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1A:</span>
                    <textarea id='txtObjectiveA_1' name='txtObjectiveA_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1B:</span>
                    <textarea id='txtObjectiveB_1' name='txtObjectiveB_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1C:</span>
                    <textarea id='txtObjectiveC_1' name='txtObjectiveC_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Progress/Lack of Progress Towards Goals & Objectives:`}</span>
                    <textarea id='txtProgressLackOfProgress_1' name='txtProgressLackOfProgress_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 2:</span>
                    <textarea id='txtGoal_2' name='txtGoal_2' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Goal Status:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusTwo_1' name='cbGoalStatusTwo_1' className='add-only' value='Achieved' /> Achieved
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusTwo_2' name='cbGoalStatusTwo_2' className='add-only' value='ModerateProgressMade' /> Moderate Progress Made
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusTwo_3' name='cbGoalStatusTwo_3' className='add-only' value='MinimalProgressMade' /> Minimal Progress Made
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusTwo_4' name='cbGoalStatusTwo_4' className='add-only' value='NoProgressMade' /> No Progress Made
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2A:</span>
                    <textarea id='txtObjectiveA_2' name='txtObjectiveA_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2B:</span>
                    <textarea id='txtObjectiveB_2' name='txtObjectiveB_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2C:</span>
                    <textarea id='txtObjectiveC_2' name='txtObjectiveC_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Progress/Lack of Progress Towards Goals & Objectives:`}</span>
                    <textarea id='txtProgressLackOfProgress_2' name='txtProgressLackOfProgress_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 3:</span>
                    <textarea id='txtGoal_3' name='txtGoal_3' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Goal Status:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusThree_1' name='cbGoalStatusThree_1' className='add-only' value='Achieved' /> Achieved
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusThree_2' name='cbGoalStatusThree_2' className='add-only' value='ModerateProgressMade' /> Moderate Progress Made
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusThree_3' name='cbGoalStatusThree_3' className='add-only' value='MinimalProgressMade' /> Minimal Progress Made
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusThree_4' name='cbGoalStatusThree_4' className='add-only' value='NoProgressMade' /> No Progress Made
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 3A:</span>
                    <textarea id='txtObjectiveA_3' name='txtObjectiveA_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 3B:</span>
                    <textarea id='txtObjectiveB_3' name='txtObjectiveB_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 3C:</span>
                    <textarea id='txtObjectiveC_3' name='txtObjectiveC_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Progress/Lack of Progress Towards Goals & Objectives:`}</span>
                    <textarea id='txtProgressLackOfProgress_3' name='txtProgressLackOfProgress_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 4:</span>
                    <textarea id='txtGoal_4' name='txtGoal_4' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Goal Status:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusFour_1' name='cbGoalStatusFour_1' className='add-only' value='Achieved' /> Achieved
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusFour_2' name='cbGoalStatusFour_2' className='add-only' value='ModerateProgressMade' /> Moderate Progress Made
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusFour_3' name='cbGoalStatusFour_3' className='add-only' value='MinimalProgressMade' /> Minimal Progress Made
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusFour_4' name='cbGoalStatusFour_4' className='add-only' value='NoProgressMade' /> No Progress Made
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 4A:</span>
                    <textarea id='txtObjectiveA_4' name='txtObjectiveA_4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 4B:</span>
                    <textarea id='txtObjectiveB_4' name='txtObjectiveB_4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 4C:</span>
                    <textarea id='txtObjectiveC_4' name='txtObjectiveC_4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Progress/Lack of Progress Towards Goals & Objectives:`}</span>
                    <textarea id='txtProgressLackOfProgress_4' name='txtProgressLackOfProgress_4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Goal 5:</span>
                    <textarea id='txtGoal_5' name='txtGoal_5' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Goal Status:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusFive_1' name='cbGoalStatusFive_1' className='add-only' value='Achieved' /> Achieved
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusFive_2' name='cbGoalStatusFive_2' className='add-only' value='ModerateProgressMade' /> Moderate Progress Made
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusFive_3' name='cbGoalStatusFive_3' className='add-only' value='MinimalProgressMade' /> Minimal Progress Made
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGoalStatusFive_4' name='cbGoalStatusFive_4' className='add-only' value='NoProgressMade' /> No Progress Made
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 5A:</span>
                    <textarea id='txtObjectiveA_5' name='txtObjectiveA_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 5B:</span>
                    <textarea id='txtObjectiveB_5' name='txtObjectiveB_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 5C:</span>
                    <textarea id='txtObjectiveC_5' name='txtObjectiveC_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Progress/Lack of Progress Towards Goals & Objectives:`}</span>
                    <textarea id='txtProgressLackOfProgress_5' name='txtProgressLackOfProgress_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>SNAP</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strength:</span>
                    <textarea id='txtStrength' name='txtStrength' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs:</span>
                    <textarea id='txtNeeds' name='txtNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities:</span>
                    <textarea id='txtAbilities' name='txtAbilities' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences:</span>
                    <textarea id='txtPreferences' name='txtPreferences' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>Referrals</h3>
                    <span className='small'>(Specify Location, Address, Telephone Number, and a Contact Person, in the boxes provided below)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MCO/Case Manager</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbMcoCaseManager_Yes' name='rbMcoCaseManager' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMcoCaseManager_No' name='rbMcoCaseManager' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbMcoCaseManager_NA' name='rbMcoCaseManager' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Name/Address/Phone#/Date & Time of appointment (if N/A please specify why):`}</span>
                    <textarea id='txtMcoCaseManager' name='txtMcoCaseManager' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Psychiatrist</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbPsychiatrist_Yes' name='rbPsychiatrist' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbPsychiatrist_No' name='rbPsychiatrist' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbPsychiatrist_NA' name='rbPsychiatrist' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Name/Address/Phone#/Date & Time of appointment (if N/A please specify why):`}</span>
                    <textarea id='txtPsychiatristOne' name='txtPsychiatristOne' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Outpatient Services</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbOutpatientServices_Yes' name='rbOutpatientServices' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbOutpatientServices_No' name='rbOutpatientServices' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbOutpatientServices_NA' name='rbOutpatientServices' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Name/Address/Phone#/Date & Time of appointment (if N/A please specify why):`}</span>
                    <textarea id='txtOutpatientServices' name='txtOutpatientServices' className='add-only'></textarea>
                </p>                
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Trauma Therapy</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbTraumaTherapy_Yes' name='rbTraumaTherapy' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbTraumaTherapy_No' name='rbTraumaTherapy' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbTraumaTherapy_NA' name='rbTraumaTherapy' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Name/Address/Phone#/Date & Time of appointment (if N/A please specify why):`}</span>
                    <textarea id='txtTraumaTherapy' name='txtTraumaTherapy' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Abuse Treatment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbSubstanceAbuseTreatment_Yes' name='rbSubstanceAbuseTreatment' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSubstanceAbuseTreatment_No' name='rbSubstanceAbuseTreatment' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbSubstanceAbuseTreatment_NA' name='rbSubstanceAbuseTreatment' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Name/Address/Phone#/Date & Time of appointment (if N/A please specify why):`}</span>
                    <textarea id='txtSubstanceAbuseTreatment' name='txtSubstanceAbuseTreatment' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Food Banks/Clothing Resources</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbFoodBanksClothingResources_Yes' name='rbFoodBanksClothingResources' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbFoodBanksClothingResources_No' name='rbFoodBanksClothingResources' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbFoodBanksClothingResources_NA' name='rbFoodBanksClothingResources' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Name/Address/Phone#/Date & Time of appointment (if N/A please specify why):`}</span>
                    <textarea id='txtFoodBanksClothingResources' name='txtFoodBanksClothingResources' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Housing Resources</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbHousingResources_Yes' name='rbHousingResources' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbHousingResources_No' name='rbHousingResources' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbHousingResources_NA' name='rbHousingResources' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Name/Address/Phone#/Date & Time of appointment (if N/A please specify why):`}</span>
                    <textarea id='txtHousingResources' name='txtHousingResources' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Employment/Literacy Resources</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbEmploymentLiteracyResources_Yes' name='rbEmploymentLiteracyResources' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEmploymentLiteracyResources_No' name='rbEmploymentLiteracyResources' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbEmploymentLiteracyResources_NA' name='rbEmploymentLiteracyResources' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Name/Address/Phone#/Date & Time of appointment (if N/A please specify why):`}</span>
                    <textarea id='txtEmploymentLiteracyResources' name='txtEmploymentLiteracyResources' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other Resources</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbOtherResources_Yes' name='rbOtherResources' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbOtherResources_No' name='rbOtherResources' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbOtherResources_NA' name='rbOtherResources' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`(Please give details, status of call/connection):`}</span>
                    <textarea id='txtOtherResources' name='txtOtherResources' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Aftercare Recommendations/ Discharge Plan:`}</span>
                    <textarea id='txtAftercaeRecommendation' name='txtAftercaeRecommendation' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Client or Parent / Guardian </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Person Completing Form/Title </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Person Completing Form/Title </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Clinical Supervisor/Title </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}







